module.exports = "assets/img/facade_google_map.png";